__turbopack_context__.v({
  "dropdown": "dropdown-module-scss-module__uZ7nHG__dropdown",
  "popover": "dropdown-module-scss-module__uZ7nHG__popover",
});
